import { extractMeta } from "../../../common/utilities/dropFieldContainerHelper";
import { isReferenceDateField } from "../../../common/utilities/isReferenceDateField";
import { isDimensionMeta } from "../../../common/utilities/metaUtils";
import type {
  DraggableFieldType,
  DraggableMetaType,
  FieldWrapper,
  ReportField,
} from "../../../../../../../../../api/types/svTypes.ts";

export const canDropItem = (item: FieldWrapper<DraggableFieldType> | DraggableMetaType, fields: ReportField[]) => {
  const meta = extractMeta(item);
  if (!meta) {
    return false;
  }
  if (isDimensionMeta(meta)) {
    if (meta.options?.supportAggregation === false) {
      return false;
    }
    if (isReferenceDateField(meta)) {
      return !fields.some((v) => isReferenceDateField(v.meta));
    }
    return true;
  }
  return true;
};
